import React from 'react';
import { Show, SimpleShowLayout, TextField } from 'react-admin';

const PrestacionesShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="descripcion" />
    </SimpleShowLayout>
  </Show>
);

export default PrestacionesShow;
